module.exports = __webpack_public_path__ + "static/img/logo.bd187bec.svg";